import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { CloseReviewEntryModuleName } from '@/store/modules/modules'

export class CloseReviewEntryViewModel {
  private store = useStore()

  entryList: ComputedRef<ReviewEntry[]> = computed(() => this.store.getters[`${CloseReviewEntryModuleName}/entryList`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${CloseReviewEntryModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${CloseReviewEntryModuleName}/error`])

  async fetchReviewEntryList(userId: string, problemId: string): Promise<void> {
    await this.store.dispatch(`${CloseReviewEntryModuleName}/fetchReviewEntryList`, { userId, problemId })
  }
}
